<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
            
        </div>

    </nav> -->

    <div class="container-fluid page-body-wrapper"
        style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <div class="main-panel">
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;">
                <div class="page-header">
                    <h2 class="page-title text-primary">DASHBOARD</h2>
                </div>


            </div>


            <div class="content-wrapper">
                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <iframe width="1140" height="541.25"
                            [src]="sNoOfBoeURL1"
                            frameborder="0" allowFullScreen="true"></iframe>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <iframe width="1140" height="541.25"
                            [src]="sInvoiceURL1"
                            frameborder="0" allowFullScreen="true"></iframe>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <iframe width="1140" height="541.25"
                            [src]="sInvItmURL1"
                            frameborder="0" allowFullScreen="true"></iframe>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 grid-margin">
                <iframe width="1140" height="541.25" [src]="sBondURL1" frameborder="0" allowFullScreen="true"></iframe>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 grid-margin">
                <iframe width="1140" height="541.25" [src]="sLicenseURL1" frameborder="0" allowFullScreen="true"></iframe>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 grid-margin">
                <!-- <iframe width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=92a4154c-7b15-41b2-b6b0-65d048a47568&autoAuth=true&ctid=101c474e-f007-4b87-a1f4-7e5ea3466c24&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWluZGlhLWNlbnRyYWwtYS1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9?filter=InvoiceHeader/OnboardingId eq 2" frameborder="0" allowFullScreen="true"></iframe> -->
                <iframe width="1140" height="541.25" [src]="sGstURL1" frameborder="0" allowFullScreen="true"></iframe>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 grid-margin">
                <iframe width="1140" height="541.25" [src]="sFtaURL1" frameborder="0" allowFullScreen="true"></iframe>
            </div>
        </div>
            </div>

            <!-- partial:../../partials/_footer.html -->
            <footer class="footer">
                <div class="d-sm-flex justify-content-center">
                    <span class="d-block d-sm-inline-block">
                        © 2020 All Rights Reserved
                        <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                            <img src="../../assets/Logo-V3.png" width="70" />
                        </a>

                    </span>

                </div>
            </footer>
            <!-- partial -->
        </div>
    </div>
</div>